<template>
  <Scroll :height="height">
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div style="background:#eee;padding: 20px" v-for="item in orders" @click="cardClick(item)">
      <Card :bordered="false" style="text-align:left">
        <p slot="title">{{item.workOrderType}}工单 工单编号：{{item.workOrderId}}</p>
        <p>地址：{{item.completeAddress}}</p>
        <p v-show="item.customerName">用户姓名：{{item.customerName}}</p>
        <p>工单发起时间：{{timestampToTime(item.workOrderInsertDatestamp)}}</p>
        <p v-if="item.repairHistoryAppointmentDatestamp != undefined">工单预约时间：{{timestampToTime(item.repairHistoryAppointmentDatestamp)}}</p>
        <p v-if="item.checkHistoryAppointmentDatestamp != undefined">工单预约时间：{{timestampToTime(item.checkHistoryAppointmentDatestamp)}}</p>
        <p>预计施工周期：{{item.workOrderCycle}} {{item.workOrderCycleUnit}}</p>
      </Card>
    </div>
  </Scroll>
</template>

<script>
export default {
  props: {
    ordertype: {},
    onOk: {
      //定义onOK属性
      type: Function
    }
  },
  mounted() {
    this.request();
  },
  created() {
    // this.height = document.body.clientHeight - 42;
    // this.width = document.body.clientWidth;
  },
  data() {
    return {
      isSpinShow: false,
      orders: [],
      height: document.body.clientHeight * 0.7
    };
  },
  methods: {
    // 时间戳转换成时间
    timestampToTime(timestamp) {
      let date = new Date(timestamp);
      return global.dateFtt("yyyy-MM-dd hh:mm:ss", date);
    },
    cardClick(item) {
      if (this.onOk) {
        this.onOk(item);
      }
    },
    request() {
      var that = this;
      that.isSpinShow = true;
      $.ajax({
        url: "/api/getOrderList",
        contentType: "application/json",
        type: "post",
        dataType: "json",
        data: JSON.stringify({
          type: that.ordertype
        }),
        success: function(data) {
          console.log(data);
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          // that.$Notice.success({
          //   title: "提示",
          //   desc: "载入工单数据成功"
          // });
          that.orders = data.body;
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.isSpinShow = false;
        }
      });
    }
  }
};
</script>